<template>
  <div class="company-setup-page" dir="rtl" :style="{ backgroundImage: 'url(/img/background-companysetup.webp)' }">
    <div class="card">
      <header class="card-header">
        <h2>راه‌اندازی سامانه</h2>
        <p class="subtitle">جهت استفاده از سامانه ممنون می‌شویم اطلاعات زیر را پر نمایید.</p>
      </header>

      <form class="card-body" @submit.prevent="submitForm">
        <div class="fields">
          <div class="field">
            <label>نام <span class="required-star">*</span></label>
            <input v-model="form.firstName" type="text" placeholder="مثال: علی" required aria-required="true" />
          </div>
          <div class="field">
            <label> نام خانوادگی <span class="required-star">*</span></label>
            <input v-model="form.lastName" type="text" placeholder="مثال: رضایی" required aria-required="true" />
          </div>

          <!-- <div class="field">
            <label>نام شرکت / مجموعه / کلینیک / مطب</label>
            <input v-model="form.companyName" type="text" placeholder="مثال: کلینیک سینا" />
          </div> -->

          <div class="field">
            <label>تلفن همراه <span class="required-star">*</span></label>
            <input v-model="form.mobileNumber" class="mobile-input" type="tel" placeholder="09xxxxxxxxx" required aria-required="true" disabled />
          </div>

          <div class="field">
            <label>ایمیل</label>
            <input
              ref="emailInputRef"
              v-model.trim="form.email"
              type="text"
              inputmode="email"
              autocomplete="email"
              placeholder="info@example.com"
              @input="handleEmailInput"
              @invalid.prevent="handleEmailInvalid"
            />
          </div>
        </div>

        <!-- <section class="products">
          <label class="products-label">محصول انتخابی (می‌توانید یک یا چند مورد را انتخاب کنید)</label>
          <div class="chips">
            <button
              v-for="item in productOptions"
              :key="item.value"
              type="button"
              :class="['chip', { 'chip--active': selectedProducts.includes(item.value) } ]"
              @click="toggleProduct(item.value)">
              {{ item.label }}
            </button>
          </div>
        </section> -->

        <div class="actions">
          <button class="btn btn-primary" type="submit">ذخیره و ادامه</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import router from '@/router';
import { useToast } from 'vue-toastification';
import axios from 'axios';

const toast = useToast();

const productOptions = [
  { value: 'accounting', label: 'حسابداری' },
  { value: 'treasury', label: 'خزانه داری' },
  { value: 'taxpayers', label: 'مودیان' },
  { value: 'sales', label: 'فروش' },
  { value: 'inventory', label: 'انبار' },
  { value: 'secretariat', label: 'دبیرخانه' },
  { value: 'archive', label: 'بایگانی' },
  { value: 'call_registration', label: 'ثبت تماس' },
  { value: 'attendance', label: 'حضور و غیاب' },
  { value: 'payroll', label: 'حقوق و دستمزد' },
  { value: 'messaging', label: 'پیام رسان' },
  { value: 'clinic_system', label: 'سامانه مطب' },
  { value: 'pos_automation', label: 'سامانه فروشگاهی' },
  { value: 'real_estate', label: 'املاک' },
  { value: 'restaurant', label: 'رستوران' }
];

const form = ref({
  firstName: '',
  lastName: '',
  // NOTE: in the rest of the app (e.g. user-area) mobile is stored as `mobileNumber`
  mobileNumber: '',
  email: ''
});

const emailInputRef = ref(null);
const EMAIL_INVALID_MESSAGE = 'لطفا یک ایمیل معتبر وارد نمایید.';

const isValidEmail = (value) => {
  const v = (value || '').trim();
  if (!v) return true; // email is optional
  // Simple, practical check; avoids browser-native localized errors.
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
};

const applyEmailValidity = () => {
  const el = emailInputRef.value;
  if (!el) return;
  if (!isValidEmail(form.value.email)) el.setCustomValidity(EMAIL_INVALID_MESSAGE);
  else el.setCustomValidity('');
};

const handleEmailInput = () => {
  applyEmailValidity();
};

const handleEmailInvalid = () => {
  // Called when the form is submitted and the email is invalid.
  applyEmailValidity();
  emailInputRef.value?.reportValidity?.();
};

const selectedProducts = ref([]);

onMounted(() => {
  try {
    const stored = JSON.parse(localStorage.getItem('companyInfo')) || {};
    // Pre-fill from backend-cached companyInfo (set at login), similar to user-area
    if (stored.form) Object.assign(form.value, stored.form);
    if (stored.mobileNumber && !form.value.mobileNumber) form.value.mobileNumber = stored.mobileNumber;
    if (stored.firstName && !form.value.firstName) form.value.firstName = stored.firstName;
    if (stored.lastName && !form.value.lastName) form.value.lastName = stored.lastName;
    if (stored.email && !form.value.email) form.value.email = stored.email;
    if (Array.isArray(stored.products)) selectedProducts.value = stored.products;
  } catch (e) {
    // ignore
  }
});

const toggleProduct = (value) => {
  const idx = selectedProducts.value.indexOf(value);
  if (idx === -1) selectedProducts.value.push(value);
  else selectedProducts.value.splice(idx, 1);
};

const validate = () => {
  if (!form.value.firstName || !form.value.lastName || !form.value.mobileNumber) {
    toast.error('لطفاً نام و نام خانوادگی و تلفن همراه را وارد کنید.', { position: 'top-right' });
    return false;
  }
  if (!isValidEmail(form.value.email)) {
    toast.error(EMAIL_INVALID_MESSAGE, { position: 'top-right' });
    // Also trigger browser bubble (but with our Persian message)
    handleEmailInvalid();
    return false;
  }
  // if (selectedProducts.value.length === 0) {
  //   toast.error('لطفاً حداقل یک محصول انتخاب کنید.', { position: 'top-right' });
  //   return false;
  // }
  return true;
};

const API_URL = process.env.VUE_APP_BACKEND_URL;
const submitForm = async () => {
  if (!validate()) return;

  localStorage.setItem('companySetup', JSON.stringify(form.value));
  localStorage.setItem('companyisactive', 'true');

  // Keep companyInfo updated for other pages (user-area reads mobileNumber from here)
  try {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo')) || {};
    localStorage.setItem('companyInfo', JSON.stringify({ ...companyInfo, ...form.value }));
  } catch (e) {
    // ignore
  }

  // Backend endpoint historically expects `phoneNumber`; we send both to stay compatible.
  const payload = { ...form.value, phoneNumber: form.value.mobileNumber };
  const resp = await axios.post(`${API_URL}/Authenticate/UpdateUserInfo`, payload, {
    headers: { 'Content-Type': 'application/json' }
  })


  toast.success('اطلاعات با موفقیت ذخیره شد. در حال هدایت...', { position: 'top-right' });
  // Redirect to a sensible default dashboard
  router.push({ path: '/overview/clinic/clinic-dashboard' });
};

// skipToDashboard removed — submission uses submitForm which handles activation and redirect
</script>

<style scoped>
.company-setup-page {
  display: flex;
  justify-content: center;
  padding: 2.2rem 1rem;
  direction: rtl;
  text-align: right;
  min-height: 100vh;
  align-items: center;
}

.card {
  width: 100%;
  max-width: 820px;
  background: var(--background-color);
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(20, 20, 40, 0.06);
  overflow: hidden;
}

.card-header {
  padding: 1.4rem 1.6rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.card-header h2 {
  margin: 0;
  font-size: 1.25rem;
}

.subtitle {
  margin: 6px 0 0;
  color: var(--text-color-secondary);
  font-size: 0.95rem;
}

.card-body {
  padding: 1.4rem 1.6rem;
}

.fields {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.field {
  display: flex;
  flex-direction: column;
}

.field label {
  margin-bottom: 6px;
  color: var(--text-color-secondary);
  font-size: 0.95rem;
  text-align: right
}

.field input {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid var(--text-color-secondary);
  background: var(--background-color);
  text-align: right
}

/* Make mobile readonly-looking (disabled + gray) */
.field input.mobile-input[disabled] {
  background: rgba(var(--text-color-secondary-rgb), 0.08);
  border-color: rgba(var(--text-color-secondary-rgb), 0.25);
  color: var(--text-color-secondary);
  cursor: not-allowed;
}

.required-star {
  color: var(--color-danger, #e53935);
  margin-left: 6px;
}

.products {
  margin-top: 14px;
}

.products-label {
  display: block;
  margin-bottom: 8px;
  color: var(--text-color-secondary);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  direction: rtl
}

/* chips should follow the app theme primary color */
.chip {
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: transparent;
  cursor: pointer;
  color: var(--text-color-primary);
  transition: all .15s ease;
}

.chip--active {
  background: var(--background-color-button);
  color: var(--text-color-forthly, #fff);
  border-color: transparent;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.chip:hover {
  transform: translateY(-2px);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px
}

.btn {
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  cursor: pointer
}

/* primary buttons follow the app theme variables (consistent across themes) */
.btn-primary {
  background: var(--background-color-button);
  color: var(--text-color-forthly, #fff);
  transition: background-color .12s ease, transform .12s ease;
}

.btn-primary:hover:not(:disabled) {
  background: var(--background-color-button-hover);
  transform: translateY(-1px);
}

.btn-primary:focus {
  outline: none;
  box-shadow: 0 0 0 0.12rem rgba(var(--background-color-button-rgb, 20, 116, 242), 0.12);
}

.btn-ghost {
  background: transparent;
  color: var(--text-color-primary);
  border: 1px solid rgba(0, 0, 0, 0.06)
}

@media (max-width: 700px) {
  .fields {
    grid-template-columns: 1fr;
  }

  .card {
    padding: 0;
  }

  .card-header,
  .card-body {
    padding-left: 12px;
    padding-right: 12px
  }
}
</style>
